import type { OneToTen, ScaleSelectorProps, SleepScaleData } from "@qendo/profile/journal";
import type { ScaleType } from "@qendo/trackables";
import type { DateArg } from "date-fns";
import { TimePicker } from "~/components/form/date-picker/TimePicker";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RangeInput } from "~/components/form/RangeInput";

export type SleepSelectorProps = ScaleSelectorProps<ScaleType.sleep>;

export const SleepSelector = ({ value, onUpdateScale, disabled, error, zIndex }: SleepSelectorProps) => {
    const changeScale = (val: number) => {
        const quality = val === 0 ? null : (Math.max(1, Math.min(10, val)) as OneToTen);
        (value.value ?? 0) !== val && onUpdateScale({ ...value, value: quality } as SleepScaleData);
    };

    const changeStart = (val: DateArg<Date> | null) => {
        val !== value.start && onUpdateScale({ ...value, start: val } as SleepScaleData);
    };

    const changeEnd = (val: DateArg<Date> | null) => {
        val !== value.end && onUpdateScale({ ...value, end: val } as SleepScaleData);
    };

    return (
        <>
            <FieldGroup zIndex={zIndex}>
                <TimePicker
                    value={value.start}
                    onDateSelected={changeStart}
                    label="When did you fall sleep?"
                    disabled={disabled}
                    error={error}
                />
                <TimePicker
                    value={value.end}
                    onDateSelected={changeEnd}
                    disabled={disabled}
                    label="When did you wake up?"
                />
            </FieldGroup>
            <FieldGroup zIndex={zIndex}>
                <RangeInput
                    label="Quality of sleep"
                    min={1}
                    max={10}
                    step={1}
                    value={value.value ?? 0}
                    onValueChange={changeScale}
                    disabled={disabled}
                    optional
                />
            </FieldGroup>
        </>
    );
};
